import { Injectable } from '@angular/core';
import { HttpClient,  HttpHeaders} from '@angular/common/http';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ClassService {

  token: string='eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJsb2dpbkF1ZGl0SWQiOjAsIm9yZ2FuaXphdGlvbklkIjozLCJ1c2VySWQiOjksInNlc3Npb25JZCI6ImFkZmRkIiwiYXV0aHRva2VuIjoicHBwcHBwIiwidXNlclNvdXJjZSI6IjEuMC4xLjEiLCJzb3VyY2VUeXBlIjoiV2ViIn0.Dt_V5DlC8BJeF3UN4go5UqZz0fofz3YBnM8iGtUCBrI';


  constructor(private http: HttpClient) { }

  getAllClasses() {
    const headers = new HttpHeaders()
    .set('token', this.token);
    return this.http.get<any>(`${environment.financeURl}Class/ClassHierarchy`,{headers:headers});
  }

  checkClass(id) {
    const headers = new HttpHeaders()
    .set('token', this.token);
    return this.http.get<any>(`${environment.inventoryURl}Product/CheckClassProductAssociation?classId=${id}`,{headers:headers});
  }

  deleteClass(id) {
    const headers = new HttpHeaders()
    .set('token', this.token);
    return this.http.delete<any>(`${environment.financeURl}Class/${id}`,{headers:headers})
    .toPromise()
    .then(res => res);
  }

  addClass(data) {
    const headers = new HttpHeaders()
    .set('token', this.token);
    return this.http.post<any>(`${environment.financeURl}Class`, data, {headers: headers})
      .toPromise()
      .then(res => res);
  }

  updateClass(data) {
    const headers = new HttpHeaders()
    .set('token', this.token);
    return this.http.put<any>(`${environment.financeURl}Class`, data, {headers: headers})
      .toPromise()
  }
}
